var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("PageNotFound")]),_c('iu-button',{on:{"click":_vm.linkToSchedule}},[_vm._v("Manage my schedule")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }